import React, { useEffect, useRef, useState } from 'react';
import './RecentlyViewedProducts.scss';
import Slider from 'react-slick';
import { v4 } from 'uuid';
import OdArrowLeftIcon from '../../../../static/assets/svg/od-arrow-left-grey-icon.svg';
import OdArrowRightIcon from '../../../../static/assets/svg/od-arrow-right-grey-icon.svg';
import ODProductCardV2 from '../ODProductCardV2/ODProductCardV2';
import 'theme/vendor/slick.min.scss';

const SLIDES_TO_SHOW = 3;

const RecentlyViewedProducts = ({ currentProductId, device }) => {
  const [products, setProducts] = useState([]);
  const sliderRef = useRef(null);

  useEffect(() => {
    const odRecentlyViewedProductList =
      __CLIENT__ && localStorage && localStorage.getItem('recentlyViewedProducts')
        ? JSON.parse(localStorage.getItem('recentlyViewedProducts'))
        : [];

    if (odRecentlyViewedProductList?.length > 0) {
      if (currentProductId)
        setProducts(
          odRecentlyViewedProductList.filter(product => product?.id !== currentProductId)
        );
      else setProducts(odRecentlyViewedProductList);
    }
  }, []);

  const config = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: SLIDES_TO_SHOW,
    slidesToScroll: 1,
    centerPadding: '40px',
  };

  if (products?.length > 0) {
    return (
      <div className="od-pdp-rv">
        <div className="od-pdp-rv__top">
          <div className="od-pdp-rv__top__title">Recently Viewed</div>
          <div className="od-pdp-rv__range__wrapper">
            <img
              alt="next"
              className="od-pdp-rv__slider__prev"
              src={OdArrowLeftIcon}
              onClick={() => sliderRef.current.slickPrev()}
            />
            <img
              alt="next"
              className="od-pdp-rv__slider__next"
              src={OdArrowRightIcon}
              onClick={() => sliderRef.current.slickNext()}
            />
          </div>
        </div>
        <Slider ref={sliderRef} {...config}>
          {products.map(product => (
            <div key={v4()}>
              <ODProductCardV2 device={device} product={product} />
            </div>
          ))}
        </Slider>
      </div>
    );
  }

  return null;
};

export default RecentlyViewedProducts;
